// extracted by mini-css-extract-plugin
export default {"chatContainer":"styles_chatContainer__GboUw","chatBody":"styles_chatBody__lSqtv","loading":"styles_loading__LThJO","chatInput":"styles_chatInput__2f35m"};